import type * as THREE from 'three'
import type { ImportedModelInstancedMeshRegistry } from '../mesh-unit'

/**
 * 将 InstancedMesh 射线命中还原成现有拓扑链可消费的 source Mesh 命中。
 *
 * 该适配器只解析 occurrence 和 source Mesh，不创建 Feature 点、线、面；精确拓扑仍由
 * ImportedModelTopologyPickResolver 负责，避免产生第二套拓扑系统。
 */
export class ImportedModelInstancedHitResolver {
  /**
   * 创建实例命中解析器。
   *
   * @param registry 当前 Viewer 的 InstancedMeshUnit 注册表。
   */
  public constructor(
    private readonly registry: ImportedModelInstancedMeshRegistry,
  ) {}

  /**
   * 把 raw InstancedMesh 命中映射为原始显示 Mesh 命中。
   *
   * @param hit Three.js 原始命中。
   * @returns source Mesh 命中；普通对象原样返回；失效下标返回 `null`。
   */
  public resolve(
    hit: THREE.Intersection<THREE.Object3D>,
  ): PuppyCAD.ImportedModelResolvedRaycastHit | null {
    const unit = this.registry.resolve(hit.object)
    if (!unit) {
      return hit
    }
    const instanceIndex = hit.instanceId
    if (typeof instanceIndex !== 'number') {
      return null
    }
    const entry = unit.getSnapshot().resolveEntry(instanceIndex)
    if (!entry) {
      return null
    }
    return {
      ...hit,
      object: entry.sourceMesh,
      instanceId: undefined,
      importedModelInstanceEntry: entry,
    }
  }
}
